import axios from "axios";
import { base_url } from "../../components/backendurl/url";
import { getCookie } from "./cookieUtils";

// Prevent concurrent refresh calls — only one reload in flight at a time.
let isRefreshing = false;

export const RefreshToken = async (error, msgState, notificationState) => {
  try {
  if (error?.response?.request?.status == 401) {
    if (isRefreshing) return;
    isRefreshing = true;
    let response = await axios.post(`${base_url}/api/accounts/token/refresh/`, {
      refresh: getCookie('refresh'),
    });
    // localStorage.setItem("refresh", response?.data?.refresh);
    // localStorage.setItem("token", response?.data?.access);
    // document.cookie = `token=${response?.data?.access || ""}; path=/; SameSite=None; Secure`;
    // document.cookie = `refresh=${response?.data?.refresh || ""}; path=/; SameSite=None; Secure`;
       const isHttps = window.location.protocol === "https:";
          const sameSite = isHttps ? "None" : "Lax";
          const secureFlag = isHttps ? "; Secure" : "";

          document.cookie = `token=${response?.data?.access || ""}; path=/; SameSite=${sameSite}${secureFlag}`;
          document.cookie = `refresh=${response?.data?.refresh || ""}; path=/; SameSite=${sameSite}${secureFlag}`;
  
    window.location.reload();
    
  } else if (error?.response?.request?.status == 400) {
  let message =   Object.keys(error?.response.data).map(item=>{
      return `${item} : ${error?.response.data[item][0]} `
    }).join("")
    msgState(message)
    notificationState(true);

  } 
  else if (error?.response?.request?.status == 403) {
      // Handle 403 Access Denied error
      const message = error?.response?.data?.message || "Access Denied";
      msgState(message);
      notificationState(true);
      
    } else {
    msgState(error.message?error.message:"Can't make a request" );
    notificationState(true);
  }
  }
  catch (err) {
    isRefreshing = false;
    // Only redirect to login if refresh token itself is invalid/expired
    if (err?.response?.status === 401 || err?.response?.status === 400) {
      localStorage.clear();
      document.cookie = 'token=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      document.cookie = 'refresh=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;';
      window.location.pathname = "/auth/login";
    } else {
      msgState(err.message || "Network error — please try again");
      notificationState(true);
    }
  }
};
